/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("StartMenuSeparatorController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class StartMenuSeparatorController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class StartMenuSeparatorController extends cls.ControllerBase /** @lends classes.StartMenuSeparatorController.prototype */ {
    static __name = "StartMenuSeparatorController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
    }

    _getWidgetType(kind) {
      let type;
      switch (kind) {
        case "poptree":
        // poptree isn't implemented, using tree instead
        /* falls through */
        case "tree":
          type = "StartMenuSeparator";
          break;
        case "menu":
          type = "TopMenuSeparator";
          break;
      }
      return type;
    }
  }

  cls.StartMenuSeparatorController = StartMenuSeparatorController;
  cls.ControllerFactory.register("StartMenuSeparator", cls.StartMenuSeparatorController);
});
